module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_6005.d80b6de8.png";